var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bg-white"},[_c('Nav')],1),_vm._v(" "),_c('div',{staticClass:"body-content"},[_c('div',{staticClass:"content-wrapper"},[_c('side-nav'),_vm._v(" "),_c('div',{staticClass:"main-content"},[_c('router-view')],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c00c65c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pc/document/index.vue
// module id = null
// module chunks = 